export default {
      id: "icon-arrow-up-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite.svg#icon-arrow-up",
      toString: function () {
        return this.url;
      }
    }